import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App.js'
import './index.scss'
import { store } from "./app/store";
import { Provider } from 'react-redux';
import { ToastContainer } from 'react-toastify';

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
    <Provider store={store}>
        <ToastContainer autoClose={3000} />
        <App />
    </Provider>
);